import React from 'react';
import { useState,useEffect } from "react";
import Spinner from 'react-bootstrap/Spinner';
import api from '../api/viewmyresultapi';
import loginapi from '../api/login';
import SelectedCourseItem from './SelectedCourseItem';

const SelectedCourseList = ({ setCourseError,setIsCourseSelectionOk,selectedCoursesAtParent,selectedSemester,session,accessToken,setAccessToken,setRefreshFailed}) => {
  const [isAppLoaded,setIsAppLoaded]=useState(false);
  const [selectedCourses,setSelectedCourses]=useState([]);


// Component for each semester with courses
const SemesterCourses = ({ semesterData }) => {
  let totalcredt=0;
  semesterData.courses.forEach((c)=>{
    totalcredt+=c.credit;
  })
  return (
    <div className="semestercourselistcontainer marginBottom bg-transparent ">
      <div className='semesterheader'>
        <div className='semesterheadercol'>
           <div className='semesterheadercolkey text-xs'>
              SEMESTER
           </div>
           <div className='semesterheadercolval '>
              {semesterData.semester}
           </div>
        </div>
        <div className='semesterheadercol'>
           <div className='semesterheadercolkey text-xs'>
              COURSES
           </div>
           <div className='semesterheadercolval'>
              {semesterData.courses.length}
           </div>
        </div>
        <div className='semesterheadercol'>
           <div className='semesterheadercolkey text-xs'>
              CREDITS
           </div>
           <div className='semesterheadercolval'>
              {
                totalcredt
              }
           </div>
        </div>
      </div>
      <div className='w-full flex flex-col items-center justify-center p-2'>
      {semesterData.courses.map((course, index) => (
        <SelectedCourseItem key={index} course={course} slno={index+1}/>
      ))}
      </div>
    </div>
  );
};


  useEffect( ()=>{
    loadAllSelectedCourses();
  },[selectedCoursesAtParent,selectedSemester]);
  
  
 useEffect(() => {
  let totalCourses = 0;
  selectedCourses.forEach((i) => {
    if (i.courses) {
      totalCourses += i.courses.length;
    }
  });

  if (totalCourses === 0) {
    setIsCourseSelectionOk(false);
    setCourseError(['Must select at least one course']);
  } else {
    setIsCourseSelectionOk(true);
    setCourseError([]);
  }
}, [selectedCourses, setCourseError, setIsCourseSelectionOk]);

  const loadAllSelectedCourses=async ()=>{
      //alert(JSON.stringify(loggedInStudent)+" selected sem "+selectedSemester);
       try{       
         //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
         const response=await api.post('/getAllSelectedCourses',{session:session,semester:selectedSemester},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
              //alert('ok');
              //alert(JSON.stringify( response.data)); 
          setSelectedCourses(response.data);
         //alert(response.data);
         }
         catch(err)
         {
           try{
             const config = { withCredentials: true };
             const x=await loginapi.get('/getAccessToken',config);            
             const nat=x['data']['accessToken'];
             const ufn=x['data']['userFullName'];
             const un=x['data']['userName'];
             const lt=x['data']['loginType'];
             //alert(nat);
             setAccessToken(nat);
             setRefreshFailed(false);  
                     
            
               if(lt.toLowerCase()==="student")
                 {
                       try{       
                         //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                         const response=await api.post('/getAllSelectedCourses',{session:session,semester:selectedSemester},{headers:{'Authorization':`Bearer ${nat}`}});                            
                          //alert('ok');
                          //alert(JSON.stringify( response.data)); 
                          setSelectedCourses(response.data);
                         //alert(response.data);
                     }
                     catch(err)
                     {
                       alert('refresh failed unusual'+ "line 50");
                       setAccessToken('');
                       setRefreshFailed(true);  
                     }
                   }
             }
             catch(err)
             {
               //alert('dd');
               setAccessToken(''); 
               setRefreshFailed(true);              
             }
         }         
          finally
             {
               setIsAppLoaded(true);
               //alert('app loaded'+accessToken);
             }
    }
  
  let totalCourses=0;
  let tx=``;
  if(selectedCourses)
  {
    selectedCourses.forEach((i)=>{
      if(i.courses)
      {
        totalCourses+=i.courses.length;
      }
    });
  }
  if(totalCourses===0)
  {
    //setIsCourseSelectionOk(false);
    //setCourseError(['Must select atleast one course']);
    tx=<div className='verticaldiv fullWidth centeredDiv paddiv'>
       <p className='m-1 p-1'>You have not selected any courses yet for semester {selectedSemester}.</p>    
    </div>;
  }
  else
  {
    //setIsCourseSelectionOk(true);
    //setCourseError([]);
    tx=
    <>    
      <div className='verticaldiv centrediv fullWidth'>
      <p className='marginTopm mb-4 p-1'>Your selected courses for semester {selectedSemester}</p>
      {selectedCourses
        .filter((semesterData) => semesterData.courses.length > 0) // Only keep items with non-empty courses
        .map((semesterData, index) => (
          <SemesterCourses key={index} semesterData={semesterData} />
        ))}
      </div>    
    </>;
  }
  return (
    <div className="formfillupview verticaldiv centrediv width1000 roundeddiv mt-4">
      {tx}
    </div>
  );
};

export default SelectedCourseList;
